import PropTypes from 'prop-types';

export const ErrorState = 'error';
export const WarningState = 'warning';
export const InfoState = 'info';

export const ErrorWarningInfoPropType = PropTypes.oneOf([ErrorState, WarningState, InfoState]);
